import { TemplatePage } from './types';

const easterPage: TemplatePage = {
  header: {
    color: '#F3CBD4',
    icon: 'images/video-templates/easter.jpg',
    title: 'Easter Video Templates Collection',
    title_meta: '20+ Easter Video Templates - Editable and Free',
    description_meta:
      'Spice up your spring marketing campaigns with these 20+ eye-catching Easter video templates.',
    description:
      'Spice up your spring marketing campaigns with these 20+ eye-catching Easter video templates. Engage ' +
      'your digital audiences and promote your products with Easter-themed videos that are both entertaining and informative.'
  },
  footer: {
    category: 'easter',
    description:
      'Wave.video’s collection of Easter video templates helps create engaging videos for your social media, ' +
      'website, blog, or email newsletter. All the templates are free and easy to customize to suit your ' +
      'brand’s goals.'
  },
  content: [
    {
      type: 'templates',
      title: 'Easter Video Templates',
      search: {
        category: '/Holidays & Occasions/Easter'
      }
    },
    {
      type: 'stocks',
      title: 'Easter',
      search: { name: 'easter' }
    },
    { type: 'calendar' }
  ]
};

export default easterPage;
